import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectCanUpdateFontStyleById, selectFontStyleById, updateFontStyleByIds } from '../../_redux';

const _Italic = ({ active, update, enabled }: Props) => {

    const { t } = useTranslation();

    const onClick = () => {
        if (enabled) {
            update(!active);
        }
    };

    return (
        <IconButton
            active={active} onClick={onClick} disabled={!enabled}
            title={t('styling_options.italic')}>
            <Icon type='italic' />
        </IconButton>
    );
};

type Props = {
    active: boolean;
    enabled: boolean;
    update: (bold: boolean) => void;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    active: selectFontStyleById(state, ownProps.variableIds[0]!) === 'italic',
    enabled: selectCanUpdateFontStyleById(state, ownProps.variableIds[0]!)
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    update: (italic: boolean) => {
        dispatch(updateFontStyleByIds(ownProps.variableIds, italic ? 'italic' : 'normal'));
    }
});

export const Italic = connect(
    mapStateToProps,
    mapDispatchToProps
)(_Italic);